import moment from "moment";

export const objectToQueryString = (params: Record<string, string | number | boolean>): string => {
  return Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");
};

export const formatDate = (dateString: string) => {
  const date = moment(dateString, "MM/DD/YYYY");
  const today = moment();
  const yesterday = moment().subtract(1, "days");

  if (date.isSame(today, "day")) {
    return "Today";
  } else if (date.isSame(yesterday, "day")) {
    return "Yesterday";
  } else {
    return date.format("MMMM D, YYYY");
  }
};
